
<h2 class="info-dialog-heading">{{data.dialogConfig.InfoHeader | translate}}</h2>

<mat-dialog-content class="dialog-content">
  @if (data.dialogConfig?.InfoSubheader) {
    <span class="subheader" [innerHTML]="data.dialogConfig.InfoSubheader | translate"></span>
  }
  <span class="questionInfo" [innerHTML]="data.dialogConfig.InfoText | translate"></span>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true" id="info-close-button" class="c-btn c-btn--primary">Close</button>
</mat-dialog-actions>

